const translation = {
  daysInWeek: {
    Thu: 'Четвер',
    Fri: 'Вільний',
    Sun: 'Сонце',
    Tue: 'Вівторок',
    Mon: 'Мон',
    Sat: 'Субота',
    Wed: 'Середа',
  },
  months: {
    August: 'Серпень',
    January: 'Січень',
    October: 'Жовтень',
    June: 'Червень',
    September: 'Вересень',
    February: 'Лютий',
    November: 'Листопад',
    July: 'Липень',
    May: 'Травень',
    December: 'Грудень',
    April: 'Квітень',
    March: 'Березень',
  },
  operation: {
    cancel: 'Скасувати',
    pickDate: 'Виберіть дату',
    now: 'Тепер',
    ok: 'Добре',
  },
  title: {
    pickTime: 'Виберіть час',
  },
  defaultPlaceholder: 'Виберіть час...',
}

export default translation
